module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "progress-view"
  }, [_vm._l((4), function(i) {
    return [_c('VwProgress', {
      attrs: {
        "value": _vm.value[i - 1]
      },
      nativeOn: {
        "click": function($event) {
          _vm.resetVal($event)
        }
      }
    })]
  })], true)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-3264234e!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/progressView.vue
// module id = 228
// module chunks = 0